import { Model, Factory, belongsTo } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import type { SchemaAttributes } from '../types.js'
import type { MockServer, MirageServer } from './server'
import { filterable, pageable } from './utils.js'
import { randCatchPhrase, randNumber, randAlphaNumeric } from '@ngneat/falso'

export type DiagnosisData = SchemaAttributes<'Diagnosis'>

export const model = (Model as ModelDefinition<DiagnosisData>).extend({
  department: belongsTo('department'),
})

export const factory = Factory.extend<DiagnosisData>({
  label() {
    return randCatchPhrase()
  },
  code() {
    return randNumber({ min: 10000, max: 99999 })
  },
  display_code() {
    return randAlphaNumeric({ length: 5 }).join('').toUpperCase()
  },
  synonyms() {
    return null
  },
})

export function routes(server: MockServer) {
  server.get(
    '/departments/:id/diagnoses',
    function (this: MirageServer, schema, request) {
      const departmentId = request.params.id
      const diagnoses = schema.where('diagnosis', { departmentId })

      const filtered = filterable(diagnoses, request, {
        search: (item, value) =>
          item.attrs.label?.toLowerCase().includes(value.toLowerCase()),
      })

      const { data, meta } = pageable(filtered, request)

      return {
        ...this.serialize(data),
        meta: {
          pagination: meta,
        },
      }
    },
  )
}

export function seeds(server: MockServer) {
  const firstDepartment = server.schema.first('department')
  if (firstDepartment) {
    server.createList('diagnosis', 20, { department: firstDepartment })
  }
}
